import '../styles/Loader.scss'

const Loader = ({ show }) =>
    <>
        {show &&
            <div className="typeInSec d-flex">
                Please wait
                <div className="typing_copy">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        }
    </>
export default Loader;
